import classNames from "classnames";
import React from "react";
import styles from "./ConfigurationLabelComposed.module.css";
import { TagCategory, getTagCategory } from "./tag-category";

type ConfigurationLabelComposedProps = {
  focusedText: string;
  peripheryTexts: string[];
  hoist?: boolean;
  coloredTags?: boolean;
  className?: string;
};

const HoistMarker = () => <span className={styles["hoist-marker"]}>H</span>;

const CATEGORY_CHIP_CLASS: Record<TagCategory, string> = {
  execview: styles["chip-execview"],
  p2: styles["chip-p2"],
  reporting: styles["chip-reporting"],
  other: styles["chip-other"],
};

export const ComposedLabel = (props: ConfigurationLabelComposedProps) => (
  <span
    className={classNames(props.className, styles["tree-container"], {
      [styles["chips"]]: props.coloredTags,
    })}
  >
    <span className={styles["focus-text"]}>
      {props.hoist && <HoistMarker />}
      {props.focusedText}
    </span>

    {props.peripheryTexts.map((text, idx) =>
      props.coloredTags ? (
        <span
          key={[idx, text].join("_")}
          className={classNames(
            styles["chip"],
            CATEGORY_CHIP_CLASS[getTagCategory(text)],
          )}
        >
          {text}
        </span>
      ) : (
        <span key={[idx, text].join("_")} className={styles["periphery-text"]}>
          {text}
        </span>
      ),
    )}
  </span>
);
